import { useCallback, useState } from "react"
import styles from "./Settings.module.css"
import { useNavigate } from "react-router-dom"
import { Button, Input, InputLabel } from "@mui/material"

export default function Settings() {
    const [ffttFile, setFfttFile] = useState<File | null>(null)
    const [helloAssoFile, setHelloAssoFile] = useState<File | null>(null)
    const navigate = useNavigate()
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token: string | null = localStorage.getItem("token")
    
    const handleFfttChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
        setFfttFile(event.target.files[0])
        }
    }, [ffttFile])

    const handleHelloAssoChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
        setHelloAssoFile(event.target.files[0])
        }
    }, [helloAssoFile])

    const handleFfttSubmit = useCallback(async (event: React.FormEvent) => {
        event.preventDefault()
        if (ffttFile && token) {
            const formData = new FormData()
            formData.append('file', ffttFile)
            formData.append('filename', 'fftt')
            try {
                const response = await fetch(`${API_BASE_URL}/uploadExcel`, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        "Authorization": `${token}`,
                    }
                })
                if (response.status === 401) {
                    navigate("/auth")
                }
                if (!response.ok) {
                    throw new Error('Erreur lors de l\'upload du fichier');
                }
        
                const data = await response.json();
                alert(`Fichier envoyé avec succès : ${data.file_path}`);
            } catch (error) {
                console.error('Erreur:', error);
                alert('Erreur lors de l\'envoi du fichier');
            }
        }
    }, [ffttFile])

    const handleHelloAssoSubmit = useCallback(async (event: React.FormEvent) => {
        event.preventDefault()
        if (helloAssoFile && token) {
            const formData = new FormData()
            formData.append('file', helloAssoFile)
            formData.append('filename', 'helloAsso')
            try {
                const response = await fetch(`${API_BASE_URL}/uploadExcel`, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        "Authorization": `${token}`,
                    }
                })
                if (response.status === 401) {
                    navigate("/auth")
                }
                if (!response.ok) {
                    throw new Error('Erreur lors de l\'upload du fichier');
                }
        
                const data = await response.json();
                alert(`Fichier envoyé avec succès : ${data.file_path}`);
            } catch (error) {
                console.error('Erreur:', error);
                alert('Erreur lors de l\'envoi du fichier');
            }
        }
    }, [helloAssoFile])

    return (<>
         <div className={styles.formContainer}>
            <form onSubmit={handleFfttSubmit}>
            <InputLabel color="primary" htmlFor="ffttFile">Fichier FFTT</InputLabel>
            <Input color="primary" type="file" onChange={handleFfttChange} />
            <Button variant="outlined" type="submit" disabled={!ffttFile}>envoyer</Button>
            </form>
            <form onSubmit={handleHelloAssoSubmit}>
            <InputLabel htmlFor="helloAssoFile">Fichier HelloAsso</InputLabel>
            <Input type="file" onChange={handleHelloAssoChange} />
            <Button variant="outlined" type="submit" disabled={!helloAssoFile}>envoyer</Button>
            </form>
        </div>
   </>)
}